import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=03367342&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03367342')) {
      api.createRecord('03367342', component.options)
    } else {
      api.reload('03367342', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=03367342&", function () {
      api.rerender('03367342', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TJEiIG3Bw3ol/JS/comp/ImgFallback.vue"
export default component.exports